import React from 'react';
import FooterSeo from './FooterSeo';

const Footer = () => {
    const year = new Date().getFullYear().toString();
    return (
        <footer className="navbar footer justify-content-center">
            <div className="row">
                <div className="col-12">
                    <FooterSeo />
                </div>
                <div className="col-12 text-center">
                    <span className="navbar-text">&copy; Ailsa Lyn {year}</span>
                </div>
            </ div>
        </footer>
    );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/Footer.js